/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Data_AnswerInputs */

const en_faq_data_answer = /** @type {(inputs: Faq_Data_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We map the sources and permissions needed for the agreed task. Access, data handling and any third-party services are discussed before implementation. Requirements vary by system, so these decisions are part of the scope.`)
};

const lv_faq_data_answer = /** @type {(inputs: Faq_Data_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs izkārtojam avotus un piekļuves, kas nepieciešamas saskaņotajam uzdevumam. Piekļuvi, datu apstrādi un jebkurus trešo pušu pakalpojumus pārrunājam pirms ieviešanas. Prasības katrai sistēmai atšķiras, tāpēc šie lēmumi ir daļa no apjoma.`)
};

/**
* | output |
* | --- |
* | "We map the sources and permissions needed for the agreed task. Access, data handling and any third-party services are discussed before implementation. Requir..." |
*
* @param {Faq_Data_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_data_answer = /** @type {((inputs?: Faq_Data_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Data_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_data_answer(inputs)
	return en_faq_data_answer(inputs)
});